"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthoriserTexts = void 0;
const authoriser_constants_1 = require("../../../authoriser/constants/authoriser.constants");
const types_1 = require("../../../authoriser/types");
const useAuthoriserTexts = (componentConfig) => {
    return {
        challenges: {
            [types_1.ChallengeType.OTP]: () => (0, authoriser_constants_1.getOTPTexts)(componentConfig),
            [types_1.ChallengeType.OTP_LOGIN]: () => (0, authoriser_constants_1.getOTPTexts)(componentConfig),
            [types_1.ChallengeType.TRUSTED_CONFIRMATION]: () => (0, authoriser_constants_1.getTrustedTexts)(componentConfig),
            [types_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN]: () => (0, authoriser_constants_1.getTrustedTexts)(),
            [types_1.ChallengeType.SIGNATURE_KEY]: authoriser_constants_1.getSignatureKeyTexts,
            [types_1.ChallengeType.OTP_IVR]: authoriser_constants_1.getIvrTexts,
            [types_1.ChallengeType.SIGNATURE_KEY_IVR]: authoriser_constants_1.getIvrTexts,
            [types_1.ChallengeType.BIOCHECK]: authoriser_constants_1.getBiocheckTexts,
            [types_1.ChallengeType.FOUR_EYES]: authoriser_constants_1.getFourEyesTexts,
        },
        modal: authoriser_constants_1.getModalTexts,
        globalErrorMessages: {
            failed: authoriser_constants_1.getFailedTexts,
            blocked: authoriser_constants_1.getBlockedTexts,
        },
    };
};
exports.useAuthoriserTexts = useAuthoriserTexts;
exports.default = exports.useAuthoriserTexts;
//# sourceMappingURL=useAuthoriserTexts.js.map